import _implicitStylesheets from "./textArea.css";
import _implicitScopedStylesheets from "./textArea.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div${"c0"}${2}>${"t1"}</div>`;
const $fragment2 = parseFragment`<div class="slds-badge slds-m-left_medium${0}"${2}>${"t1"}</div>`;
const $fragment3 = parseFragment`<div class="overview${0}"${2}>${"t1"}</div>`;
const $fragment4 = parseFragment`<textarea${"a0:maxlength"}${"a0:placeholder"}${"a0:data-id"}${"c0"}${"a0:disabled"}${"a0:required"}${"a0:rows"}${2}>${"t1"}</textarea>`;
const $fragment5 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment6 = parseFragment`<span class="help-text${0}"${2}>${"t1"}</span>`;
const $fragment7 = parseFragment`<div${"c0"}${2}>${"t1"}</div>`;
const stc0 = {
  "label": true
};
const stc1 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_align-spread": true
  },
  key: 9
};
const stc2 = {
  classMap: {
    "slds-col": true
  },
  key: 10
};
const stc3 = {
  classMap: {
    "required-message": true
  },
  key: 11
};
const stc4 = {
  classMap: {
    "slds-col": true
  },
  key: 16
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, b: api_bind} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5} = $ctx;
  return [$cmp.label ? api_element("label", {
    classMap: stc0,
    attrs: {
      "id": api_scoped_id("textAreaLabel")
    },
    key: 0
  }, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    className: api_normalize_class_name($cmp.requiredCss)
  }, null), api_static_part(1, null, api_dynamic_text($cmp.label))]), $cmp.badge ? api_static_fragment($fragment2, 4, [api_static_part(1, null, api_dynamic_text($cmp.badge))]) : null]) : null, $cmp.overview ? api_static_fragment($fragment3, 6, [api_static_part(1, null, api_dynamic_text($cmp.overview))]) : null, api_static_fragment($fragment4, 8, [api_static_part(0, {
    on: {
      "input": _m3 || ($ctx._m3 = api_bind($cmp.onChanged)),
      "focus": _m4 || ($ctx._m4 = api_bind($cmp.onFocus)),
      "blur": _m5 || ($ctx._m5 = api_bind($cmp.onBlur))
    },
    className: api_normalize_class_name($cmp.cssClass),
    attrs: {
      "maxlength": $cmp.maxLength,
      "placeholder": $cmp.placeholder,
      "data-id": $cmp.identifier,
      "disabled": $cmp.disabled ? "" : null,
      "required": $cmp.required ? "" : null,
      "rows": $cmp.rows
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.value))]), api_element("div", stc1, [api_element("div", stc2, [api_element("div", stc3, [$cmp.showRequiredError ? api_static_fragment($fragment5, 13, [api_static_part(1, null, api_dynamic_text($cmp.requiredText))]) : null]), $cmp.showHelpInputMessage ? api_static_fragment($fragment6, 15, [api_static_part(1, null, api_dynamic_text($cmp.helpInputMessage))]) : null]), api_element("div", stc4, [$cmp.showRemainingCharactersInfo ? api_static_fragment($fragment7, 18, [api_static_part(0, {
    className: api_normalize_class_name($cmp.remainingCharactersCSS)
  }, null), api_static_part(1, null, api_dynamic_text($cmp.charactersRemainingDescription))]) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4oejvu0ht2j";
tmpl.legacyStylesheetToken = "c360-textArea_textArea";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
